import Reveal from "../landing/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Fenomeno() {
  const { t } = useLanguage();

  return (
    <section id="fenomeno" className="bg-cream py-20 md:py-28" data-testid="fenomeno-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <p className="kicker" data-testid="fenomeno-kicker">{t.fenomeno.kicker}</p>
          <h2 className="mt-5 max-w-4xl font-display text-3xl font-bold leading-tight text-forest-800 md:text-4xl lg:text-5xl">
            {t.fenomeno.title}
          </h2>
          <div className="mt-6 h-px w-24 bg-forest-800" aria-hidden="true" />
        </Reveal>

        <div className="mt-12 grid gap-12 lg:grid-cols-3">
          <Reveal className="space-y-8">
            <div>
              <h3 className="font-body text-[11px] font-bold uppercase tracking-[0.25em] text-forest-800">
                {t.fenomeno.side1Title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-forest-800/75">{t.fenomeno.side1Text}</p>
            </div>
            <div className="callout p-6" data-testid="fenomeno-dato-box">
              <h3 className="font-body text-[11px] font-bold uppercase tracking-[0.25em] text-forest-800">
                {t.fenomeno.side2Title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-forest-800/75">{t.fenomeno.side2Text}</p>
            </div>
          </Reveal>

          <div className="lg:col-span-2">
            <Reveal>
              <p className="text-base leading-relaxed text-forest-800 md:text-lg">{t.fenomeno.lead}</p>
            </Reveal>
            <div className="mt-8">
              {t.fenomeno.items.map((item, index) => (
                <Reveal key={item.n} delay={index * 0.1}>
                  <div className="rule flex gap-8 py-7" data-testid={`fenomeno-item-${item.n}`}>
                    <span className="font-display text-3xl font-bold text-forest-700/60 md:text-4xl">{item.n}</span>
                    <div>
                      <h3 className="font-display text-xl font-bold text-forest-800 md:text-2xl">{item.t}</h3>
                      <p className="mt-2 max-w-2xl text-sm leading-relaxed text-forest-800/75">{item.d}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
              <div className="rule" aria-hidden="true" />
            </div>
          </div>
        </div>

        <Reveal className="mt-16">
          <div className="border-t-2 border-forest-800 pt-8">
            <blockquote className="max-w-4xl font-display text-xl italic leading-relaxed text-forest-800 md:text-2xl" data-testid="fenomeno-quote">
              “{t.fenomeno.quote}”
            </blockquote>
            <p className="kicker mt-4">{t.fenomeno.quoteCaption}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
